'use client';

import {
  preferredUsernameQuery,
  supporterAddressQuery,
  supporterContactsQuery,
} from '../queries.ts';
import { useSupporterQuery } from './base.ts';
import { useSupporterDetails } from './details.ts';

// TODO: Do we want to also expose loading or error states?
export const useAccountSettings = () => {
  const { data: supporter, isLoading: supporterDataLoading } =
    useSupporterDetails();
  const { data: supporterAddress, isLoading: addressDataLoading } =
    useSupporterQuery(supporterAddressQuery);
  const { data: preferredUsername, isLoading: preferredUsernameLoading } =
    useSupporterQuery(preferredUsernameQuery);
  const { data: contacts } = useSupporterQuery(supporterContactsQuery);

  return {
    supporter,
    supporterAddress,
    preferredUsername,
    contacts,
    showSkeleton:
      supporterDataLoading || addressDataLoading || preferredUsernameLoading,
  };
};
